<div class=" mt-4">
    <section>
        <div class="row">
            <div class="col-md-10">
                <!-- <div class="float-right">
                    <button class="btn dash-btns mr-3" [routerLink]="['/pos/payment/new']">New Payments</button>
                    <button class="btn dash-btns" [routerLink]="['/pos/payment/manage']">Manage Payments</button>
                </div> -->
            </div>
        </div>

    </section>
    <section class="mt-3">
        <div class="">
            <div class="row">
                <div class="col-md-7">
                    <div class="card-1">
                        <div class="row">
                            <div class="col-md-12">
                                <!-- <div class="text-center mb-5">
                                    <img src="assets/img/new/view-trans.svg" />
                                </div> -->
                                <div class="text-center">
                                    <a class="view-h gary-t">View Payment View</a>
                                </div>

                                <div class="pt-3">
                                    <div class=" ">
                                        <div class="row mb-3">
                                            <div class="col-md-6 p-0 label1">
                                                ManagerApprovalRequiredForRefundAboveAmount</div>

                                            <div class="col-md-6 view-text">
                                                {{rows.managerApprovalRequiredForRefundAboveAmount}}</div>
                                        </div>
                                        <div class="row mb-3">
                                            <div class="col-md-6 p-0 label1">DontRequiredSignForTranUnderAmount</div>

                                            <div class="col-md-6 view-text"> {{rows.dontRequiredSignForTranUnderAmount}}
                                            </div>
                                        </div>
                                        <div class="row mb-3">
                                            <div class="col-md-6 p-0 label1">SetDefaultPreAuthAmount</div>

                                            <div class="col-md-6 view-text"> {{rows.setDefaultPreAuthAmount}}</div>
                                        </div>


                                        <div class="row mb-3">
                                            <div class="col-md-6 p-0 label1"> Date Time</div>

                                            <div class="col-md-6 view-text"> {{ rows.dateTime| date:'d/M/yy, h:mm a' }}
                                            </div>
                                        </div>

                                        <div class="row mb-3">
                                            <div class="col-md-6 p-0 label1">SignatureOption</div>

                                            <div class="col-md-6 view-text"> {{rows.signatureOption}}</div>
                                        </div>
                                        <div class="row mb-3">
                                            <div class="col-md-6 p-0 label1">EnablePreAuth</div>

                                            <div class="col-md-6 view-text"> <input type="checkbox"
                                                    [(ngModel)]="rows.enablePreAuth" id="EnablePreAuth"
                                                    name="EnablePreAuth" >
                                            </div>
                                        </div>
                                        <div class="row mb-3">
                                            <div class="col-md-6 p-0 label1">AlwaysRequiredSignature</div>

                                            <div class="col-md-6 view-text">
                                                <input type="checkbox" [(ngModel)]="rows.alwaysRequiredSignature"
                                                    id="AlwaysRequiredSignature" name="AlwaysRequiredSignature" >
                                            </div>
                                        </div>
                                        <div class="row mb-3">
                                            <div class="col-md-6 p-0 label1">EnableFastPayWithCashRegister</div>

                                            <div class="col-md-6 view-text"> <input type="checkbox"
                                                    [(ngModel)]="rows.enableFastPayWithCashRegister"
                                                    id="EnableFastPayWithCashRegister"
                                                    name="EnableFastPayWithCashRegister" >
                                            </div>
                                        </div>
                                        <div class="row mb-3">
                                            <div class="col-md-6 p-0 label1">LogOutAfterEachOrder</div>

                                            <div class="col-md-6 view-text"> <input type="checkbox"
                                                    [(ngModel)]="rows.logOutAfterEachOrder" id="LogOutAfterEachOrder"
                                                    name="LogOutAfterEachOrder" >
                                            </div>
                                        </div>
                                        <div class="row mb-3">
                                            <div class="col-md-6 p-0 label1">AlwaysRequiredManagerApprovalForRefund
                                            </div>

                                            <div class="col-md-6 view-text">
                                                <input type="checkbox"
                                                    [(ngModel)]="rows.alwaysRequiredManagerApprovalForRefund"
                                                    id="AlwaysRequiredManagerApprovalForRefund"
                                                    name="AlwaysRequiredManagerApprovalForRefund" >
                                            </div>
                                            
                                        </div>
                                        <div class="text-right  ">
                                            <button class="btn dash-btns" [routerLink]="['/pos/payment/manage']">Back</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-5">
                    <div class="text-center mb-5">
                        <img src="assets/img/new/pos.svg" />
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>








<!-- 



<section  >
    <div class="block-header">
        <div class="">
            <div class="row ">
                <div class="col-md-12  p-0">
                    <h2 class="poppins font-weight-bold pl-2"> Payment</h2>
                </div>
                <div class=" col-md-5 px-6 col-sm-12 p-0">

                    <div class="breadcrumb flat">
                        <a [routerLink]="['/pos']">

                            Home
                        </a>
                        <a [routerLink]="['/pos/payment/manage']">Manage Payment View</a>
                        <a href="#" class="active"> View Payment View</a>
                    </div>
                </div>
                <div class="col-md-7">
                    <div class="float-right">
                       
                    </div>
                </div>
            </div>
        </div>

    </div>
    <div class="container">
        <div class="row">
            <div class="col-md-12 p-0">
                <div class=" card px-2 py-4 poppins border" style="box-shadow: none; border-radius: 10px;">
                    <div class="row mx-0">
                        <div class="col-md-12 ">
                            <h4 class="font-weight-bold">View Payment View</h4>
                        </div>

                    </div>
                    <div class="row mx-0">

                      
                        <div class="col-md-5">
                            <div class="b">
                                <img src="assets/img/payment-solutions.png" alt="Tips"
                                    style="display: block; width: 100%;">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
  -->